import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

const MarketAppPlaceholder = ({ isMobileView, className, onAddApp }) => {
  if (isMobileView) {
    return (
      <div
        onClick={() => onAddApp(true)}
        className={cx('market-app-mobile-placeholder', className)}
      >
        <span className="hicon-plus-alt" />
      </div>
    );
  }

  return (
    <div onClick={() => onAddApp(true)} className={cx('market-app-desktop-placeholder', className)}>
      <span>Choose App</span>
      <span className="hicon-angle-right-alt" />
    </div>
  );
};

MarketAppPlaceholder.propTypes = {
  isMobileView: T.bool.isRequired,
  className: T.string,
  onAddApp: T.func.isRequired,
};

export default MarketAppPlaceholder;
